type UserDataResetter = () => void

const resetters = new Set<UserDataResetter>()

/**
 * 注册需要在退出账号时清理的领域状态。
 * 该模块保持无业务依赖，避免被请求拦截器引用时形成初始化循环。
 */
export function registerUserDataResetter(reset: UserDataResetter) {
  resetters.add(reset)
  return () => resetters.delete(reset)
}

export function resetRegisteredUserData() {
  resetters.forEach(reset => {
    try {
      reset()
    } catch (error) {
      console.error('[user-data-reset] reset failed:', error)
    }
  })
}
